import { Toaster as SonnerToaster, type ToasterProps } from 'sonner';
import { useTheme } from '@/lib/theme/ThemeProvider';

export function Toaster(props: ToasterProps) {
  const { theme } = useTheme();
  const resolved: 'dark' | 'light' | 'system' =
    theme === 'dark' ? 'dark' : theme === 'light' ? 'light' : 'system';
  return (
    <SonnerToaster
      theme={resolved}
      richColors
      closeButton
      position="top-right"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
}
